import { render, staticRenderFns } from "./BindsCardHeader.vue?vue&type=template&id=95713c4e&"
import script from "./BindsCardHeader.vue?vue&type=script&lang=js&"
export * from "./BindsCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./BindsCardHeader.vue?vue&type=style&index=0&id=95713c4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports